export const SUBJECTS = ["Math", "English", "Reasoning", "GK"];

export const SUBJECT_LABELS = {
  Math: "Math",
  English: "English",
  Reasoning: "Reasoning",
  GK: "GK / Current Affairs",
};

export const SUBJECT_COLORS = {
  Math: { bg: "#EEEDFA", text: "#5B4FCF", dot: "#5B4FCF" },
  English: { bg: "#FAEAED", text: "#C0415A", dot: "#C0415A" },
  Reasoning: { bg: "#E3F2EE", text: "#1A7A5E", dot: "#1A7A5E" },
  GK: { bg: "#FDF3E3", text: "#C07800", dot: "#C07800" },
};
